var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error"}},[_c('div',{staticClass:"content"},[_c('p',[_vm._v("出现错误请稍后再访问......")]),_c('van-button',{attrs:{"type":"default"},on:{"click":_vm.reload}},[_vm._v("重新加载")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }